import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectAssociatedAccounts,
  selectAssociatedAccountsLoading,
  selectAssociatedAccountsState,
  useFetchAssociatedAccountsQuery,
  useLazyFetchAssociatedAccountsQuery,
} from '../actions/fetchAssociatedAccounts';

export interface IUseAssociatedAccounts extends IUseQueryProps {}

export const useAssociatedAccounts = ({
  skipFetching,
}: IUseAssociatedAccounts = {}) => {
  useFetchAssociatedAccountsQuery(
    getQueryParams({ params: undefined, skipFetching }),
  );

  const [handleFetchAssociatedAccounts] = useLazyFetchAssociatedAccountsQuery();

  const associatedAccounts = useAppSelector(selectAssociatedAccounts);

  const loading = useAppSelector(selectAssociatedAccountsLoading);

  const state = useAppSelector(selectAssociatedAccountsState);

  return { associatedAccounts, handleFetchAssociatedAccounts, loading, state };
};
